import { QD_CLOUD_LOCAL_STORAGE_KEY } from '../config/localStorage'
import { getDataApiBaseUrl, getAuthorizationUrl } from '../config/runtime'

export async function authorize(state: string) {
	const url = (await getAuthorizationUrl()) + `&state=${state}`
	window.location.href = url
}

export async function logout(redirectUrlPath?: string, error?: string) {
	return fetch((await getDataApiBaseUrl()) + 'logout/', {
		credentials: 'include',
		method: 'POST',
	}).then(() => {
		try {
			localStorage.removeItem(QD_CLOUD_LOCAL_STORAGE_KEY)
		} catch {
			console.error(`Couldn't clear localStorage`)
		}

		if (redirectUrlPath) {
			// returning a promise that will never resolve (leaves the logout button disabled until the end of the redirect)
			return new Promise((_, reject) => {
				try {
					// TODO: test in Safari < 14
					const redirectUrl = new URL(redirectUrlPath, window.location.origin)
					if (error) {
						redirectUrl.searchParams.set('error', 'logout_reason')
						redirectUrl.searchParams.set('error_description', error)
					}

					window.location.href = redirectUrl.toString()
				} catch {
					reject()
				}
			})
		}
	})
}
